import { brands } from 'noddi-types';

const BOOKING_HORIZON_DAYS_BY_BRAND: Partial<Record<string, number>> = {
  [brands.tronderdekk]: 35
};

/** Days ahead the stationary proposal picker may reach, for every customer — personal and organization alike. */
export const getStationaryProposalBookingHorizonDays = (brandDomain: string) =>
  BOOKING_HORIZON_DAYS_BY_BRAND[brandDomain];

/**
 * Brands whose stationary proposal opens on three suggested times instead of the
 * full calendar. Keep it an explicit list — every other brand keeps the picker.
 */
const SUGGESTED_TIMES_BRANDS: string[] = [brands.tronderdekk];

export const showsSuggestedProposalTimes = (brandDomain: string) => SUGGESTED_TIMES_BRANDS.includes(brandDomain);
